import { RouteFactory } from "@app/routePaths";
import { BT_NEWSLETTERS } from "@components/Newsletter/types/Newsletter";

export const NEWSLETTER_PAGE_LINK = RouteFactory.newsletterSignup;
export const PREMIUM_NEWSLETTERS = BT_NEWSLETTERS.slice(8);
export const DAILY_NEWSLETTERS = BT_NEWSLETTERS.slice(0, 2);
export const WEEKLY_NEWSLETTERS = BT_NEWSLETTERS.slice(2, 8);
export const newsletterLinks = [
  { linkText: "Premium Newsletters" },
  { linkText: "Daily Newsletters" },
  { linkText: "Weekly Newsletters" },
];

export const BIGMONEY_SUBSCRIBE_CTA =
  "https://subscribe.sph.com.sg/promotions/bt-personal/?utm_campaign=bt_subscription&utm_medium=sph-publication&utm_source=bt&utm_content=Newsletterlistingpage-Bigmoney-subscribebutton";
